import api from "../services/api";

export const fetchUsers = async (page = 1, size = 20) => {
  try {
    const params = {
      page,
      size,
    };

    const response = await api.get("auth/users", {
      params,
      withCredentials: true,
    });

    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Failed to fetch users:", error.message || error);
    return { error: error.response?.data?.detail || "Failed to fetch users" };
  }
};

export const registerUser = async (userData) => {
  try {
    const response = await api.post("auth/register", userData, {
      withCredentials: true,
    });
    
    if (response.status === 200) {
      return response.data;
    }
    
    throw new Error(response.data?.detail || "Unexpected response from server");
  } catch (error) {
    console.error("Registration error:", error);
    
    if (error.response?.data?.detail) {
      if (Array.isArray(error.response.data.detail)) {
        const errorMessages = error.response.data.detail.map(err => {
          const field = err.loc.join('.').replace('body.', '');
          return `${field}: ${err.msg}`;
        });
        throw new Error(errorMessages.join('\n'));
      }
      throw new Error(error.response.data.detail);
    }
    
    throw new Error(error.message || "Failed to register user");
  }
};

export const fetchProfile = async () => {
  try {
    // Make the request to fetch the profile
    const response = await api.get("auth/profile/me", { withCredentials: true });

    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Failed to fetch profile:", error.message || error);
    return { error: error.response?.data?.detail || "Failed to fetch profile" };
  }
};

export const updateUserAdmin = async (userId, payload) => {
  try {
    const response = await api.put(
      `auth/admin/user/${userId}`,
      payload,
      { withCredentials: true }
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      console.warn("Unexpected Response:", response);
      return { success: false, error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating user:", error.message || error);

    return {
      success: false,
      error: error.response?.data?.detail || "Failed to update user",
    };
  }
};